import { TQuerySpecialDealUser } from '@src/modules/special-deal-user'

import { request } from './config'

export const getLisSpecialDealUser = (params: TQuerySpecialDealUser, token: string) =>
  request({ url: 'special-deal-user', method: 'GET', params }, { token })
export const removeSpecialDealUserById = (id: string) => request({ url: `special-deal-user/${id}`, method: 'DELETE' })
export const changeSpecialDealUserById = (data: { ids: string[] }, token: string) =>
  request({ url: 'special-deal-user/status-change', method: 'POST', data }, { token })
export const removeManySpecialDealUserByIds = (ids: string[]) =>
  request({ url: `special-deal-user/delete-many`, method: 'POST', data: { ids } })
export const exportListSpecialDealUser = (params: TQuerySpecialDealUser, token: string) =>
  request(
    {
      url: 'special-deal-user/export-xlsx',
      method: 'GET',
      params,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    },
    { token },
  )
